<template>
  <div class="programs">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.programs {
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (max-width:768px) {
    padding: 0;
  }
}
</style>
